import {

    SHORT_URL_LIST_REQUEST,
    SHORT_URL_LIST_SUCCESS,
    SHORT_URL_LIST_FAIL,

    SHORT_URL_DETAILS_REQUEST,
    SHORT_URL_DETAILS_SUCCESS,
    SHORT_URL_DETAILS_FAIL,
    SHORT_URL_DETAILS_RESET,

    SHORT_URL_DELETE_REQUEST,
    SHORT_URL_DELETE_SUCCESS,
    SHORT_URL_DELETE_FAIL,

    SHORT_URL_CREATE_REQUEST,
    SHORT_URL_CREATE_SUCCESS,
    SHORT_URL_CREATE_FAIL,
    SHORT_URL_CREATE_RESET,

    SHORT_URL_UPDATE_REQUEST,
    SHORT_URL_UPDATE_SUCCESS,
    SHORT_URL_UPDATE_FAIL,
    SHORT_URL_UPDATE_RESET,

    SHORT_URL_COUNT_SUCCESS,
    SHORT_URL_COUNT_REQUEST,
    SHORT_URL_COUNT_FAIL,

    SET_CURRENT_PAGE,

} from "../constants/shortUrlConstants";

const initialState = {
    shortUrls: [],
    currentPage: 1,
    totalPages: 1,
    loading: false,
    error: null
};


export const shortUrlListReducer = (
    state = {
        shortUrls: []
    }, action) => {
    switch (action.type) {
        case SHORT_URL_LIST_REQUEST:
            return { loading: true, shortUrls: [] };
        case SHORT_URL_LIST_SUCCESS:
            return {
                loading: false,
                shortUrls: action.payload.items,
                totalPages: action.payload.totalPages,
                currentPage: action.payload.currentPage,
                totalCount: action.payload.totalCount,
            };
        case SET_CURRENT_PAGE:
            return {
                ...state,
                currentPage: action.payload
            };

        case SHORT_URL_LIST_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
}

export const shortUrlCountReducer = (state = { shortUrlCounts: [] }, action) => {
  switch (action.type) {
    case SHORT_URL_COUNT_REQUEST:
      return { loading: true, shortUrlCounts: [] };
    case SHORT_URL_COUNT_SUCCESS:
      return { loading: false, shortUrlCounts: action.payload };
    case SHORT_URL_COUNT_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const shortUrlDetailsReducer = (
    state = {
        shortUrl: { comments: [] }
    }, action) => {
    switch (action.type) {
        case SHORT_URL_DETAILS_REQUEST:
            return { loading: true, ...state };
        case SHORT_URL_DETAILS_SUCCESS:
            // our state will have a list of shortUrls after the request
            return { loading: false, shortUrl: action.payload };
        case SHORT_URL_DETAILS_FAIL:
            return { loading: false, error: action.payload };
        case SHORT_URL_DETAILS_RESET:
            return { shortUrl: {} };
        default:
            return state;
    }
}

// short url details by userId
export const shortUrlDetailsByUserIdReducer = (
    state = {
        shortUrl: { comments: [] }
    }, action) => {
    switch (action.type) {
        case SHORT_URL_DETAILS_REQUEST:
            return { loading: true, ...state };
        case SHORT_URL_DETAILS_SUCCESS:
            // our state will have a list of shortUrls after the request
            return { loading: false, shortUrl: action.payload };
        case SHORT_URL_DETAILS_FAIL:
            return { loading: false, error: action.payload };
        case SHORT_URL_DETAILS_RESET:
            return { shortUrl: {} };
        default:
            return state;
    }
}

export const shortUrlDetailsByCodeReducer = (
    state = {
        shortUrl: { comments: [] }
    }, action) => {
    switch (action.type) {
        case SHORT_URL_DETAILS_REQUEST:
            return { loading: true, ...state };
        case SHORT_URL_DETAILS_SUCCESS:
            // our state will have a list of shortUrls after the request
            return { loading: false, shortUrl: action.payload };
        case SHORT_URL_DETAILS_FAIL:
            return { loading: false, error: action.payload };
        case SHORT_URL_DETAILS_RESET:
            return { shortUrl: {} };
        default:
            return state;
    }
}


export const shortUrlDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case SHORT_URL_DELETE_REQUEST:
            return { loading: true }

        case SHORT_URL_DELETE_SUCCESS:
            return { loading: false, success: true }

        case SHORT_URL_DELETE_FAIL:
            return { loading: false, error: action.payload }

        default:
            return state
    }
}


export const shortUrlCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case SHORT_URL_CREATE_REQUEST:
            return { loading: true }

        case SHORT_URL_CREATE_SUCCESS:
            return { loading: false, success: true, shortUrl: action.payload }

        case SHORT_URL_CREATE_FAIL:
            return { loading: false, error: action.payload }

        case SHORT_URL_CREATE_RESET:
            return {}

        default:
            return state
    }
}


export const shortUrlUpdateReducer = (state = { shortUrl: {} }, action) => {
    switch (action.type) {
        case SHORT_URL_UPDATE_REQUEST:
            return { loading: true }

        case SHORT_URL_UPDATE_SUCCESS:
            return { loading: false, success: true, shortUrl: action.payload }

        case SHORT_URL_UPDATE_FAIL:
            return { loading: false, error: action.payload }

        case SHORT_URL_UPDATE_RESET:
            return { shortUrl: {} }

        default:
            return state
    }
}